import { take, fork, put, call, select } from 'redux-saga/effects';
import { isMobile } from 'react-device-detect';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { getLanguage, getActualLanguage, getSkinId, getToken, getUserId } from '../selectors';
import { failGameUrl, setGameUrl } from '../actionCreators/gameUrl';

import apiRoutes from '../../constants/apiRoutes';

const xpressProviderWithRedirectHome = ['EVOLUTION', 'EvoPlay'];

function* getGameUrl(game: { game: { id: any; provider: string; integrator: string; } }): any {

  try {
    const token = yield select(getToken);
    const language = yield select(getLanguage);
    const actualLanguage = yield select(getActualLanguage);
    //TODO need to merge language and actualLanguage
    const lng = language || actualLanguage;
    const skinId = yield select(getSkinId);
    const userId = yield select(getUserId);

    const params = {
      token,
      id: game?.game?.id,
      userId: userId || null,
      skinId: skinId,
      lang: lng,
      device: isMobile ? 'mobile' : 'desktop'
    };
    if (
      (isMobile && ['Vivo'].includes(game?.game?.provider)) ||
      ['Endorphina', 'Booming'].includes(game?.game?.provider) ||
      (game?.game?.integrator === 'xpress' && xpressProviderWithRedirectHome.includes(game?.game?.provider))
    ) {
    //  params.lobbyUrl = 'https://gameboxhandlers.draftplaza.com/ingameclose.php';
    }

    const response = yield call(apiGet, 'REACT_APP_REMOTE_URL', apiRoutes.GET_GAME_URL, params);

    yield put(setGameUrl(response.data.result.data.url));
  } catch (e) {
    yield put(failGameUrl(game?.game?.id));
  }
}

export default function* watchRequestGameUrl(): any {
  while (true) {
    const action = yield take(actionTypes.REQUEST_GAME_URL);
    yield fork(getGameUrl, action);
  }
}
